document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".home-slideshow__slider");
  const slides = Array.from(document.querySelectorAll(".home-slideshow__card"));
  const dotsContainer = document.querySelector(".home-slideshow__dots");

  if (!slider || slides.length === 0) return;

  // Duplicate slides for smooth infinite loop illusion
  const total = slides.length;
  slides.forEach(slide => slider.appendChild(slide.cloneNode(true)));

  let currentIndex = 0;
  const gap = 10; // matches CSS gap
  const visibleCards = 3;

  // Create dots
  slides.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.classList.add("home-slideshow__dot");
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      currentIndex = i;
      updateSlider();
    });
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll(".home-slideshow__dot");

  function updateSlider() {
    const cardWidth = slides[0].offsetWidth + gap;
    const offset = -(cardWidth * currentIndex);
    slider.style.transform = `translateX(${offset}px)`;

    dots.forEach(dot => dot.classList.remove("active"));
    dots[currentIndex % total].classList.add("active");
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % total;
    updateSlider();
  }

  // Auto-loop every 3 seconds
  let autoPlay = setInterval(nextSlide, 3000);

  // Pause on hover
  slider.addEventListener("mouseenter", () => clearInterval(autoPlay));
  slider.addEventListener("mouseleave", () => (autoPlay = setInterval(nextSlide, 3000)));

  updateSlider();
});
